import skins from '@/skins'
import { fetch as fetchTranslations } from '@/requests/staticTranslationsQuery'
import config, { setDefaultRequestParams } from '@/config'
import InstanceConfigQuery from '@/requests/instanceConfigQuery'
import { extendOrigins } from '@/config/origins'

export function preload(initParams) {
  config.extend(initParams)
  const skinConfigImport = skins[config.skinName] || skins.betsonic
  const instanceConfigQuery = new InstanceConfigQuery()
  return new Promise((resolve, reject) =>
    skinConfigImport()
      .then(result => config.extend(result.default))
      .then(result => instanceConfigQuery.fetch())
      .then(result => extendOrigins(result))
      .then(result => fetchTranslations())
      .then(result => setDefaultRequestParams())
      // .then(result => fetchAuth())
      // .then(result => fetchConfigs())
      .then(result => resolve())
      .catch(error => reject(error))
  )
}
